import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HisBackendService } from 'hisng';
import { DocumentMetadata } from 'app/fs/res/common/model/documents/documentMetadata';

@Injectable()
export class DocumentService {

    constructor( private backendService: HisBackendService ) { }

    /**
     * get document by given target entity name and target objGuid
     *
     * @param targetName name of target entity
     * @param targetObjGuid objGuid of target entity
     */
    getDocumentMetadataByTargetNameAndObjGuid( targetName: string, targetObjGuid: string ): Observable<DocumentMetadata[]> {
        return this.backendService.getData( `api/v1/cs/sys/filemanagement/documentMetadata/${targetName}/${targetObjGuid}` );
    }

    /**
     * return untrusted domain URL to download document
     *
     * @param documentMetadataId id of documentMetadata
     */
    getDocDownloadURL( documentMetadata: DocumentMetadata ): Observable<string> {
        return this.backendService.getData(
            'api/v1/cs/sys/filemanagement/docDownloadURL/'
            + `${documentMetadata.objGuid}/${documentMetadata.target}/${documentMetadata.targetId}` );
    }

    /**
     * upload file as formData parameter for targetName and targetId
     * return documentMetadata
     */
    uploadDocument( targetName: string, targetId: number, formData: FormData ): Observable<DocumentMetadata> {
        return this.backendService.postData( `api/v1/cs/sys/filemanagement/uploadFile/${targetName}/${targetId}`, formData );
    }

    /**
     * save documentMetada - contains attributes target, targetId with reference of target object
     *
     * @param documentMetadata object to save
     */
    saveDocumentMetadata( documentMetadata: DocumentMetadata ): Observable<DocumentMetadata> {
        delete documentMetadata.markForDelete;
        if ( documentMetadata.id == null ) {
            // POST returns only on documentMetadata object
            return this.backendService.postData(
                'api/v1/cs/sys/filemanagement/documentMetadata',
                documentMetadata );
        } else {
            // PUT returns only on documentMetadata object
            return this.backendService.putData(
                `api/v1/cs/sys/filemanagement/documentMetadata/${documentMetadata.objGuid}`,
                documentMetadata );
        }
    }

    /**
     * service to delete documentMetadata/mimedata from database.
     *
     * @param documentMetadataId Id of documentMetadata/mimedata to delete.
     * @return Observable containing the result of operation: null on failure, 1 on success
     */
    deleteDocumentMetadata( documentMetadata: DocumentMetadata ): Observable<number> {
        return this.backendService.delete(
            'api/v1/cs/sys/filemanagement/documentMetadata/'
            + `${documentMetadata.objGuid}/${documentMetadata.target}/${documentMetadata.targetId}` );
    }

    /**
     * get mime content file type (original file type if file type was changed manually)
     *
     * @param file File suppose to be uploaded
     */
    mimeContentType( file: File ): Observable<string> {
        // set up formData to append file
        let formData: FormData = new FormData();
        formData.append( 'file', file );
        return this.backendService.postData( 'api/v1/cs/sys/filemanagement/mimeContentType', formData );
    }
}
